import React from "react";
import { MaterialDesignIcons } from "../styled";

export const MusicNoteMIcon: React.FC<{ fontSize?: string; onClick: () => void }> = ({
  fontSize,
  onClick,
}) => {
  return (
    <MaterialDesignIcons fontSize={fontSize} onClick={onClick}>
      music_note
    </MaterialDesignIcons>
  );
};
